import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    align-self: stretch;
    width: 48%;
`

export const ConquistasContainer = styled.div`
    display: flex;
    justify-content: left;
    gap: 16px;
    width: ${({ respondsFast }) => respondsFast ? '100%' : '76%'};
`;

export const ConquistaItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    span {
        font-size: 12px;
        font-weight: 400;
        color: #696977;
        text-align: center; 
        line-height: 18px;
        max-width: 100px;
        margin: 8px 0 10px;
    }
    &#AdAreaCountAds span{
        max-width: 130px;
    }
`;

export const Title = styled.h3`
    font-size: 16px;
    color: #2E2D37;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    margin-left: 5px;
`;

export const Image = styled.img`
    width: 32px;
    height: 32px;
    flex-shrink: 0;
`;